import React, { useContext, useEffect, useRef, useState } from "react";
import Logo from "../Logo";
import userImage from "../../assets/image/user1.png";
import { NavLink, useHistory } from "react-router-dom";
import { BiBookAdd, BiLogOut } from "react-icons/bi";
import { Transition } from "@tailwindui/react";
import { LoginContext } from "../../context/loginContext";
import { GiHamburgerMenu } from "react-icons/gi";
import "./style.css";
import { publicUrl } from "../../config/api";

function Navbar(props) {
  const [show, setshow] = useState(false);
  const history = useHistory();
  // eslint-disable-next-line
  const [state, dispatch] = useContext(LoginContext);
  const container = useRef(null);
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!container.current.contains(event.target)) {
        if (!show) return;
        setshow(false);
      }
    };
    window.addEventListener("click", handleOutsideClick);
    return () => window.removeEventListener("click", handleOutsideClick);
  }, [show, container]);

  return (
    <div
      className={`flex flex-wrap w-full bg-white fixed ${
        state.user.isAdmin === "1" ? "lg:flex" : "lg:hidden"
      } flex-row justify-between px-10 py-6 z-20`}
    >
      <div className="flex items-center">
        {state.loading ? (
          <></>
        ) : state.user.isAdmin === "0" || state.user.isAdmin === null ? (
          <div>
            <GiHamburgerMenu
              className="text-2xl mr-8 cursor-pointer "
              onClick={() => props.handleShowSide()}
            />
          </div>
        ) : (
          <></>
        )}
        <Logo />
      </div>
      <div
        ref={container}
        className={`${
          state.user.isAdmin === "1" ? "" : "sm:hidden"
        } relative inline-block text-left`}
      >
        {state.user.isAdmin === "1" ? (
          <>
            <div
              onClick={() => setshow(!show)}
              className="cursor-pointer border-4 border-gray-600 shadow-xl mb-0 rounded-full mx-auto navbar-userimg"
              style={{
                backgroundImage: `url(${
                  !state.user.img ? userImage : publicUrl + "/" + state.user.img
                })`,
              }}
            ></div>
            <Transition show={show}>
              <div className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">
                <div
                  className="rounded-md bg-white shadow-xs"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu"
                >
                  <div className="py-1">
                    <NavLink
                      className="text-xl items-center font-bold flex px-3 py-4 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                      role="menuitem"
                      to="/admin/add"
                    >
                      <BiBookAdd className="self-center text-2xl mr-2" />
                      Add Book
                    </NavLink>
                    <div className="border-t-4 border-gray-400"></div>

                    <button
                      className="w-full text-xl items-center font-bold text-left flex px-3 py-4 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                      role="menuitem"
                      onClick={() => {
                        dispatch({
                          type: "LOGOUT",
                        });
                        history.push("/");
                      }}
                    >
                      <BiLogOut className="self-center text-2xl mr-2 text-red-600" />
                      Logout
                    </button>
                  </div>
                </div>
              </div>
            </Transition>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
export default Navbar;
